export default __webpack_public_path__ + "static/media/saude.0f272f5f.png";